export const typedObjKeys = <T extends number | string>(
  obj: Partial<Record<T, unknown>>,
): Array<T> => Object.keys(obj) as Array<T>;
